<template>
  <KvTable :items="items"/>
</template>
<script>
import KvTable from '@/components/Table/kvTable'

export default {
  name: 'remote-setting',
  props: ['deviceListProps', 'preSetDeviceIdProps'],
  components: {KvTable},
  data() {
    return {
      items: [
        {
          index: 0,
          keyTitle: this.$t('RMC.set_camera'),
          keyType: 'SelectOptionBox',
          class: '',
          keyRange: this.deviceListProps.cameraList,
          values: !this.preSetDeviceIdProps?.videoInputDeviceId ||
          this.deviceListProps.cameraList.filter(value => {
            return value.deviceId === this.preSetDeviceIdProps.videoInputDeviceId;
          }).length === 0 ?
              this.deviceListProps.cameraList[0] :
              this.deviceListProps.cameraList.filter(value => {
                return value.deviceId === this.preSetDeviceIdProps.videoInputDeviceId;
              })[0]
        },
        {
          index: 1,
          keyTitle: this.$t('RMC.set_mic'),
          keyType: 'SelectOptionBox',
          class: '',
          keyRange: this.deviceListProps.micList,
          values: !this.preSetDeviceIdProps?.audioInputDeviceId ||
          this.deviceListProps.micList.filter(value => {
            return value.deviceId === this.preSetDeviceIdProps.audioInputDeviceId;
          }).length === 0 ?
              this.deviceListProps.micList[0] :
              this.deviceListProps.micList.filter(value => {
                return value.deviceId === this.preSetDeviceIdProps.audioInputDeviceId;
              })[0]
        },
        {
          index: 2,
          keyTitle: this.$t('RMC.set_speaker'),
          keyType: 'SelectOptionBox',
          class: '',
          keyRange: this.deviceListProps.speakerList,
          values: !this.preSetDeviceIdProps?.audioOutputDeviceId ||
          this.deviceListProps.speakerList.filter(value => {
            return value.deviceId === this.preSetDeviceIdProps.audioOutputDeviceId;
          }).length === 0 ?
              this.deviceListProps.speakerList[0] :
              this.deviceListProps.speakerList.filter(value => {
                return value.deviceId === this.preSetDeviceIdProps.audioOutputDeviceId;
              })[0]
        }
      ]
    }
  },
  methods: {
    getValue() {
      return {
        videoInputDeviceId: this.items[0].values,
        audioInputDeviceId: this.items[1].values,
        audioOutputDeviceId: this.items[2].values
      };
    }
  },
  watch: {
    deviceListProps: {
      deep: true,
      handler(newVal) {
        this.items[0].keyRange = newVal.cameraList;
        this.items[0].values = !this.preSetDeviceIdProps?.videoInputDeviceId || newVal.cameraList.filter(item => {
          return item.deviceId === this.preSetDeviceIdProps.videoInputDeviceId;
        }).length === 0 ? newVal.cameraList[0] : newVal.cameraList.filter(item => {
          return item.deviceId === this.preSetDeviceIdProps.videoInputDeviceId;
        })[0];

        this.items[1].keyRange = newVal.micList;
        this.items[1].values = !this.preSetDeviceIdProps?.audioInputDeviceId || newVal.micList.filter(item => {
          return item.deviceId === this.preSetDeviceIdProps.audioInputDeviceId;
        }).length === 0 ? newVal.micList[0] : newVal.micList.filter(item => {
          return item.deviceId === this.preSetDeviceIdProps.audioInputDeviceId;
        })[0];

        this.items[2].keyRange = newVal.speakerList;
        this.items[2].values = !this.preSetDeviceIdProps?.audioOutputDeviceId || newVal.speakerList.filter(item => {
          return item.deviceId === this.preSetDeviceIdProps.audioOutputDeviceId;
        }).length === 0 ? newVal.speakerList[0] : newVal.speakerList.filter(item => {
          return item.deviceId === this.preSetDeviceIdProps.audioOutputDeviceId;
        })[0];
      }
    }
  }
}
</script>
<style>

</style>